/* [ASB pdp] Places the format guide next to the APO options once they load
   Custom file — not part of Dawn 15.4.0.
   Built by: Codex (2026-10)
   What it does: watches the product info for APO markup and inserts the guide from its <template>.
   Settings/data: MageWorx APO option markup.
   Used by: sections/main-product.liquid (<asb-pdp-guidance> from snippets/asb-pdp-guidance.liquid). */
if (!customElements.get('asb-pdp-guidance')) {
  customElements.define('asb-pdp-guidance', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.template = this.querySelector('template');
      if (!this.product || !this.template) return;
      // APO rebuilds its options on every size change. Re-add the guide in the observer itself (before the browser
      // paints); waiting for an animation frame left the options 49 px shorter for a moment, so the page jumped.
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.product, { childList: true, subtree: true });
      this.sync();
    }
    sync() {
      // This verified APO set supplies spray, samples and a 120 ml pump oil.
      // Other sets keep their own descriptions and controls.
      const format = this.product.querySelector('#o_3571163');
      const spray = format?.querySelector('input[id="v_27486043"]');
      const oil = format?.querySelector('input[id="v_27486044"]');
      if (!spray || !oil) return;
      if (!format.querySelector('.asb-format-guide')) {
        format.appendChild(this.template.content.cloneNode(true));
      }
      const heading = this.product.querySelector('#o_3571164 .asb-sample-heading');
      if (heading && heading.textContent !== this.dataset.samplePrompt) {
        heading.textContent = this.dataset.samplePrompt;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
